import apiClient from "@/lib/api";
import type {
  SharingStatus,
  UniversityLinkQuestion,
  UniversityLinkQuestionsResponse,
} from "./types";

// 所属大学への結果共有の状態。名簿に一致する学生だけ eligible になる。
export async function getSharingStatus() {
  const response = await apiClient.get<SharingStatus>("/university_link/sharing");
  return response.data;
}

export async function updateSharingStatus(
  enabled: boolean,
  consentVersion?: string,
) {
  const response = await apiClient.patch<SharingStatus>("/university_link/sharing", {
    enabled,
    consent_version: consentVersion,
  });
  return response.data;
}

// 所属大学が登録した練習用質問の全件。名簿に一致しなければ eligible: false と空の一覧が返る。
export async function getUniversityLinkQuestions() {
  const response = await apiClient.get<UniversityLinkQuestionsResponse>(
    "/university_link/questions",
  );
  return response.data;
}

// 練習画面用の1件。他大学・削除済み・名簿不一致は 404 になる。
export async function getUniversityLinkQuestion(id: string) {
  const response = await apiClient.get<UniversityLinkQuestion>(
    `/university_link/questions/${encodeURIComponent(id)}`,
  );
  return response.data;
}

/** 大学質問の読み上げ生成の経路。usePrepareTts の generatePath に渡す。 */
export function universityLinkQuestionTtsPath(id: string): string {
  return `/university_link/questions/${encodeURIComponent(id)}/tts`;
}
